/**
 * @file
 * Global utilities.
 *
 */
(function ($, Drupal, drupalSettings) {
	"use strict";
	Drupal.behaviors.b2ibase = {
		attach: function (context, settings) {
			// Vérification du contexte car le fichier est parcouru une 2ème fois avec
			// l'élément HTML de la barre admin
			// comme contexte. En vérifiant que context est bien égal à document, on
			// s'assure que la fonction ne sera lue qu'une fois
			// @see https://drupal.stackexchange.com/a/287227
			// console.log(context);
			if (context === document) {
				$('.main-menu .hamburger').on("click", function () {
					$(this).toggleClass('is-active');
					if($(this).hasClass('is-active')){
						if(!$(document.body).hasClass('sidenav_is-open')){
							$(document.body).addClass('sidenav_is-open');
							$(".layout-nav_side").addClass('is-open');
						}
					} else {
						$(document.body).removeClass('sidenav_is-open');
						$(".layout-nav_side").removeClass('is-open');
					}
				})
			}
		}
	};
})(jQuery, Drupal, drupalSettings);
